import { Reducer } from 'redux'

import { ValidaState, ValidaTypes } from './types'

const INITIAL_STATE: ValidaState = {
  loading: false,
}

const reducer: Reducer<ValidaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ValidaTypes.VALIDA_SET_LOADING:
      return { ...state, loading: action.payload }

    default:
      return state
  }
}

export default reducer
